<div *ngIf="greeting" class="greeting-or-period">
	{{ greeting }}
</div>
